import React from "react";
import img from "../images/web.svg";
import img2 from "../images/app.svg";
import img3 from "../images/hosting.svg";
import img4 from "../images/consultation.svg";
import react from "../images/techlogo/react.svg";
import nodejs from "../images/techlogo/nodejs.svg";
import redux from "../images/techlogo/redux.svg";
import mysql from "../images/techlogo/mysql.svg";
import nextjs from "../images/techlogo/nextjs.svg";
import threejs from "../images/techlogo/threejs.png";
import zoho from "../images/techlogo/zoho.svg";
import aws from "../images/techlogo/aws.svg";
import typescript from "../images/techlogo/typescript.svg";
import salesforce from "../images/techlogo/salesforce.svg";
import postgresql from "../images/techlogo/postgresql.svg";
import mongodb from "../images/techlogo/mongodb.svg";
import remix from "../images/techlogo/remix.svg";
import tailwind from "../images/techlogo/tailwind.svg";
import supabase from "../images/techlogo/supabase.png";
import socket from "../images/techlogo/socket-io.svg";
import firebase from "../images/techlogo/firebase.png";
import { Helmet } from "react-helmet-async";

const techStack = [
  { src: react, alt: "React", name: "React / React Native" },
  { src: nextjs, alt: "Nextjs", name: "NextJs" },
  { src: remix, alt: "Remixjs", name: "RemixJs" },
  { src: threejs, alt: "Three.js", name: "ThreeJs" },
  { src: tailwind, alt: "Tailwind css", name: "Tailwind CSS" },
  { src: typescript, alt: "Typescript", name: "Typescript" },
  { src: nodejs, alt: "Node.js", name: "Node.js" },
  { src: mongodb, alt: "mongodb", name: "MongoDB" },
  { src: firebase, alt: "firebase", name: "Firebase" },
  { src: socket, alt: "socket.io", name: "Socket.io" },
  { src: aws, alt: "AWS", name: "AWS" },
  { src: mysql, alt: "MySQL", name: "MySQL" },
  { src: postgresql, alt: "postgresql", name: "PostgreSql" },
  { src: supabase, alt: "supabase", name: "Supabase" },
  { src: zoho, alt: "Zoho", name: "Zoho" },
  { src: salesforce, alt: "salesforce", name: "salesforce" },
];

const Services = () => {
  return (
    <>
      <div id="services" className="bg-gray-100 py-12">
        <section data-aos="zoom-in-down">
          <div className="my-4 py-4">
            <h2 className="my-2 text-center text-3xl text-[#377c7d] uppercase font-bold">
              services
            </h2>

            <div className="flex justify-center">
              <div className="w-24 border-b-4 border-[#377c7d]"></div>
            </div>
            <h2 className="mt-4 mx-12 text-center text-xl lg:text-2xl font-semibold text-[#377c7d]">
              We are deeply committed to the growth and success of our clients.
            </h2>
          </div>

          <div className="px-12" data-aos="fade-down" data-aos-delay="600">
            <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
              <div className="bg-white transition-all ease-in-out duration-400  overflow-hidden text-gray-700 md:hover:bg-[#88aaa5] md:hover:text-white rounded-lg shadow-2xl p-3 group">
                <div className="m-2 text-justify text-sm">
                  <img
                    alt="card img"
                    className="rounded-t md:group-hover:scale-[1.15] transition duration-1000 ease-in-out"
                    src={img}
                  />
                  <h2 className="font-semibold my-4 text-2xl text-center text-[#377c7d] md:group-hover:text-white">
                    Web Development
                  </h2>
                  <p className="text-md font-medium">
                    We specialize in creating and optimizing high-quality,
                    custom websites for businesses and organizations of all
                    sizes. Building mobile-friendly and easy-to-use websites and
                    applications for clients.
                  </p>
                </div>
              </div>

              <div className="bg-white transition-all ease-in-out duration-400  overflow-hidden text-gray-700 md:hover:bg-[#88aaa5] md:hover:text-white rounded-lg shadow-2xl p-3 group">
                <div className="m-2 text-justify text-sm">
                  <img
                    alt="card img"
                    className="rounded-t md:group-hover:scale-[1.15] transition duration-1000 ease-in-out"
                    src={img2}
                  />
                  <h2 className="font-semibold my-4 text-2xl text-center text-[#377c7d] md:group-hover:text-white">
                    Mobile App Development
                  </h2>
                  <p className="text-md font-medium">
                    We develop high-quality, custom cross-platform mobile
                    applications that are robust and optimized for performance,
                    scalability, and accessibility.
                  </p>
                </div>
              </div>

              <div className="bg-white transition-all ease-in-out duration-400  overflow-hidden text-gray-700 md:hover:bg-[#88aaa5] md:hover:text-white rounded-lg shadow-2xl p-3 group">
                <div className="m-2 text-justify text-sm">
                  <img
                    alt="card img"
                    className="rounded-t md:group-hover:scale-[1.15] transition duration-1000 ease-in-out"
                    src={img3}
                  />
                  <h2 className="font-semibold my-4 text-2xl text-center text-[#377c7d] md:group-hover:text-white">
                    CRM Consulting
                  </h2>
                  <p className="text-md font-medium">
                    Industry-focused consulting, customization and loyalty
                    solutions for B2B and B2C enterprises based on leading CRM
                    platforms – Salesforce and ZOHO crm.
                  </p>
                </div>
              </div>

              <div className="bg-white transition-all ease-in-out duration-400  overflow-hidden text-gray-700 md:hover:bg-[#88aaa5] md:hover:text-white rounded-lg shadow-2xl p-3 group">
                <div className="m-2 text-justify text-sm">
                  <img
                    alt="card img"
                    className="rounded-t md:group-hover:scale-[1.15] transition duration-1000 ease-in-out"
                    src={img4}
                  />
                  <h2 className="font-semibold my-4 text-2xl text-center text-[#377c7d] md:group-hover:text-white">
                    3D on the Web
                  </h2>
                  <p className="text-md font-medium">
                    Craft innovative 3D web apps blending technology and design
                    with Three.js and WebGL. Experience real-time rendering and
                    immersive visuals for next-generation applications.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section>
          <div className="m-auto max-w-6xl  md:px-12 h-5/6 md:mt-4" data-aos="fade-up">
            <div
              className="flex flex-col-reverse lg:flex-row py-8 px-5 sm:px-0 justify-between lg:text-left"
              // data-aos="zoom-out"
            >
              <div className="lg:w-1/2 flex flex-col lg:mx-4 justify-center mx-4">
                {/* Row for SVG and h3 */}
                <div className="flex items-center mb-4 justify-center sm:justify-start">
                  <div className="text-[#377c7d] flex-shrink-0">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="48"
                      height="48"
                      viewBox="0 0 24 24"
                      className="fill-current"
                    >
                      <path d="M2 12h2a7.986 7.986 0 0 1 2.337-5.663 7.91 7.91 0 0 1 2.542-1.71 8.12 8.12 0 0 1 6.13-.041A2.488 2.488 0 0 0 17.5 7C18.886 7 20 5.886 20 4.5S18.886 2 17.5 2c-.689 0-1.312.276-1.763.725-2.431-.973-5.223-.958-7.635.059a9.928 9.928 0 0 0-3.18 2.139 9.92 9.92 0 0 0-2.14 3.179A10.005 10.005 0 0 0 2 12zm17.373 3.122c-.401.952-.977 1.808-1.71 2.541s-1.589 1.309-2.542 1.71a8.12 8.12 0 0 1-6.13.041A2.488 2.488 0 0 0 6.5 17C5.114 17 4 18.114 4 19.5S5.114 22 6.5 22c.689 0 1.312-.276 1.763-.725A9.965 9.965 0 0 0 12 22a9.983 9.983 0 0 0 9.217-6.102A9.992 9.992 0 0 0 22 12h-2a7.993 7.993 0 0 1-.627 3.122z"></path>
                      <path d="M12 7.462c-2.502 0-4.538 2.036-4.538 4.538S9.498 16.538 12 16.538s4.538-2.036 4.538-4.538S14.502 7.462 12 7.462zm0 7.076c-1.399 0-2.538-1.139-2.538-2.538S10.601 9.462 12 9.462s2.538 1.139 2.538 2.538-1.139 2.538-2.538 2.538z"></path>
                    </svg>
                  </div>
                  <h3 className="text-2xl sm:text-3xl text-[#377c7d] font-bold ml-4">
                    We <span className="font-black">Build</span>
                  </h3>
                </div>
                {/* Description */}
                <p className="my-3 text-base sm:text-lg text-gray-500 font-semibold text-center sm:text-left">
                  With over 9 years experience in software analysis and design
                  and a deep understanding of the latest IT trends and
                  solutions, we provide customized recommendations and
                  strategies to help you improve your operations, reduce costs,
                  and increase efficiency.
                </p>
              </div>

              <div className="lg:w-1/2 flex flex-col lg:mx-4 mx-4">
                {/* Row for SVG and h3 */}
                <div className="flex items-center mb-4 justify-center sm:justify-start">
                  <div className="text-[#377c7d] flex-shrink-0">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="48"
                      height="48"
                      viewBox="0 0 24 24"
                      className="fill-current"
                    >
                      <path d="m7.375 16.781 1.25-1.562L4.601 12l4.024-3.219-1.25-1.562-5 4a1 1 0 0 0 0 1.562l5 4zm9.25-9.562-1.25 1.562L19.399 12l-4.024 3.219 1.25 1.562 5-4a1 1 0 0 0 0-1.562l-5-4zm-1.649-4.003-4 18-1.953-.434 4-18z"></path>
                    </svg>
                  </div>
                  <h3 className="text-2xl sm:text-3xl text-[#377c7d] font-bold ml-4">
                    We <span className="font-black">Collaborate</span>
                  </h3>
                </div>
                {/* Description */}
                <p className="my-3 text-base sm:text-lg text-gray-500 font-semibold text-center sm:text-left">
                  We can collaborate with your existing tech team to scale
                  existing software applications or design customized software
                  applications that suits your everyday need and simplifies
                  various processes.
                </p>
              </div>
            </div>
          </div>
        </section>

        <section
          className="m-auto max-w-6xl sm:p-12 sm:pt-20 p-7 h-auto"
          id="technologies"
        >
          <h2 className="text-2xl sm:text-4xl text-center font-bold text-[#377c7d] mb-8">
            Our Technology Stack
          </h2>
          {/* Responsive Grid */}
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-4 gap-4 gap-x-6 mb-4">
            {techStack.map((tech, index) => (
              <div
                key={index}
                className="w-32 h-36 sm:w-40 sm:h-44 md:w-48 md:h-52 lg:w-56 lg:h-60 mx-auto flex flex-col items-center justify-center shadow-md md:hover:shadow-md border-2 hover:border-solid hover:border-[#7bafaf] transition-all duration-300 md:hover:scale-105 rounded-3xl p-1"
              >
                <img
                  src={tech.src}
                  alt={tech.alt}
                  className="w-24 h-24 md:w-28 md:h-28 transition-transform duration-300"
                />
                <p className="text-center text-sm md:text-base font-semibold mt-2">
                  {tech.name}
                </p>
              </div>
            ))}
          </div>
        </section>
      </div>
    </>
  );
};

export default Services;
